// --- SaniQ ---
import * as StudyConstants from '../constants/Studies';

const initialState = {
  study: null,
  collection: [],
  isFetching: false,
  submitLoading: false,
  sorting: {
    sort: 'asc',
    order: 'id',
    query: ''
  },
  pagination: {
    total: 0,
    perPage: 10,
    totalPages: 0,
    page: 0
  }
};

export function studies(state = initialState, action) {
  switch (action.type) {
    case StudyConstants.PATIENT_STUDY_FETCH_COMPLETED:
      return Object.assign({}, state, {study: action.study});
    case StudyConstants.PATIENT_STUDIES_FETCH_STARTED:
      return Object.assign({}, state, {isFetching: true});
    case StudyConstants.PATIENT_STUDIES_FETCH_COMPLETED:
      return Object.assign({}, state, {
        collection: action.studies,
        pagination: action.pagination,
        sorting: action.sorting,
        isFetching: false
      });
    default:
      return state;
  }
}

